import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import Button from '../../../../components/Button';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import IconBox from '../../../../components/IconBox';
import InlineNotice from '../../../../components/InlineNotice';
import ListItem from '../../../../components/ListItem';
import PageHeader from '../../../../components/PageHeader';
import QRGenerate from '../../../../components/QRGenerate/QRGenerate';
import { t } from '../../../../lang';
import HelperService from '../../../../services/HelperService';
import TypesService from '../../../../services/TypesService';

import './ReceiveQR.scss';

const COPY_ICON_SIZE = 24;
const ICON_SIZE = 20;
const BlockchainsById = TypesService.BlockchainsById;
const CurrenciesById = TypesService.CurrenciesById;

const ReceiveQR = () => {
	const navigate = useNavigate();

	const asset = useSelector(store => store.receive.asset) || {};
	const account = useSelector(store => store.receive.account) || {};
	const isCardTopUp = useSelector(store => store.receive.isCardTopUp);

	const copy = () => {
		navigator.clipboard.writeText(account.Address);

		HelperService.showNotification({
			icon: 'DOCUMENTS_ICON_PURPLE',
			title: t('Address copied'),
			description: HelperService.middleEllipsis(account.Address),
			iconSize: 32,
		});
	};

	const activeCurrency = CurrenciesById[account.CurrencyId];
	const activeBlockchain = BlockchainsById[account.BlockchainId];

	return (
		<div className='ReceiveQR'>
			<PageHeader collapsed={true} header={isCardTopUp ? 'Top up' : 'Receive'} />

			<div className='ReceiveQR__form'>
				<InlineNotice icon='EXCLAMATIONMARK_CIRCLE'>
					{t('Only send {coinName} assets to this address. Other assets will be lost forever.', {
						coinName: [activeCurrency.Name, activeCurrency.Standart].filter(Boolean).join(' '),
					})}
				</InlineNotice>

				<div className='ReceiveQR__result FormBlock'>
					<div className='ReceiveQR__info'>
						<div className='ReceiveQR__info-item'>{activeCurrency.Name}</div>
						<div className='ReceiveQR__info-item'>{`${activeBlockchain.Name}${
							activeCurrency.Standart ? ' (' + activeCurrency.Standart + ')' : ''
						}`}</div>
					</div>

					<div className='ReceiveQR__code'>
						<QRGenerate data={account.Address} />
						<div className='ReceiveQR__currency-container'>
							<div className='ReceiveQR__currency-wrapper'>
								<IconBox
									icon={asset.Symbol?.split('-')[0]}
									iconLabel={asset.Symbol !== activeBlockchain.Icon ? activeBlockchain.Icon : null}
									size='32'
								/>
							</div>
						</div>
					</div>
				</div>

				<ListItem
					className='ReceiveQR__address FormBlock'
					icon={
						<div className={'ReceiveQR__address-icon-qr'} style={{ '--color-qr': activeCurrency.Color }}>
							<Icon type={Icons.QR_CODE} width={ICON_SIZE} height={ICON_SIZE} />
						</div>
					}
					iconSize='medium'
					title={isCardTopUp ? t('Top up address') : account.AddressLabel}
					description={account.Address}
					trailing={
						isCardTopUp
							? []
							: [
									<Icon
										className='ReceiveQR__address-icon-arrow'
										type={Icons.ARROW_CHEVRON}
										width={ICON_SIZE}
										height={ICON_SIZE}
									/>,
							  ]
					}
					onSelect={() => {
						if (isCardTopUp) return;
						navigate(-1);
					}}
				/>

				<Button className='ReceiveQR__copy-button' onClick={copy} styleType='secondary'>
					<Icon
						type={Icons.DOCUMENTS_ICON}
						className='ReceiveQR__copy-icon'
						width={COPY_ICON_SIZE}
						height={COPY_ICON_SIZE}
					/>
					{t('Copy')}
				</Button>
			</div>
		</div>
	);
};

export default ReceiveQR;
